<script>
import Autocomplete from '../autocomplete/component.vue';

export default {
  mixins: [Autocomplete],
  computed: {
    query () {
      const that = this;
      const q = that.q.toLowerCase();
      const splat = q.split('.');
      return splat[splat.length - 1] || splat[splat.length - 2] || '';
    }
  }
};
</script>
